'use strict';

exports.__esModule = true;
exports.widgetActions = exports.LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS = exports.LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS = exports.LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR = exports.LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS = exports.LOAD_REVIEWS_FOR_ALL_DOCTORS = exports.LOAD_REVIEWS_STAT_FOR_ONE = exports.LOAD_REVIEWS_FOR_ONE = exports.LOAD_SPECIALIST = exports.LOAD_PRACTICE = exports.GET_PROFILE_DETAILS = exports.SET_RECOMMENDATIONS_LIMIT = exports.SET_REVIEWS_LIMIT = exports.SET_SPECIALIST = exports.SET_TAB = exports.SET_OFFSET = exports.GET_LAYOUT = undefined;

var _doctifyUtils = require('doctify-utils');

var _constats = require('../utils/constats');

// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var GET_LAYOUT = exports.GET_LAYOUT = 'WF_PEER_RECOMMENDATION:GET_LAYOUT';
var SET_OFFSET = exports.SET_OFFSET = 'WF_PEER_RECOMMENDATION:SET_OFFSET';
var SET_TAB = exports.SET_TAB = 'WF_PEER_RECOMMENDATION:SET_TAB';
var SET_SPECIALIST = exports.SET_SPECIALIST = 'WF_PEER_RECOMMENDATION:SET_SPECIALIST';
var SET_REVIEWS_LIMIT = exports.SET_REVIEWS_LIMIT = 'WF_PEER_RECOMMENDATION:SET_REVIEWS_LIMIT';
var SET_RECOMMENDATIONS_LIMIT = exports.SET_RECOMMENDATIONS_LIMIT = 'WF_PEER_RECOMMENDATION:SET_RECOMMENDATIONS_LIMIT';
var GET_PROFILE_DETAILS = exports.GET_PROFILE_DETAILS = 'WF_PEER_RECOMMENDATION:GET_PROFILE_DETAILS';

var LOAD_PRACTICE = exports.LOAD_PRACTICE = 'WF_PEER_RECOMMENDATION:LOAD_PRACTICE';
var LOAD_SPECIALIST = exports.LOAD_SPECIALIST = 'WF_PEER_RECOMMENDATION:LOAD_SPECIALIST';

var LOAD_REVIEWS_FOR_ONE = exports.LOAD_REVIEWS_FOR_ONE = 'WF_PEER_RECOMMENDATION:LOAD_REVIEWS_FOR_ONE';
var LOAD_REVIEWS_STAT_FOR_ONE = exports.LOAD_REVIEWS_STAT_FOR_ONE = 'WF_PEER_RECOMMENDATION:LOAD_REVIEWS_STAT_FOR_ONE';

var LOAD_REVIEWS_FOR_ALL_DOCTORS = exports.LOAD_REVIEWS_FOR_ALL_DOCTORS = 'WF_PEER_RECOMMENDATION:LOAD_REVIEWS_FOR_ALL_DOCTORS';
var LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS = exports.LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS = 'WF_PEER_RECOMMENDATION:LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS';

var LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR = exports.LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR = 'WF_PEER_RECOMMENDATION:LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR';
var LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS = exports.LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS = 'WF_PEER_RECOMMENDATION:LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS';
var LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS = exports.LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS = 'WF_PEER_RECOMMENDATION:LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS';

var widgetActions = exports.widgetActions = {
    getProfileDetails: function getProfileDetails(profileId, profileType, baseUrl) {
        return {
            type: GET_PROFILE_DETAILS,
            payload: {
                profileType: profileType,
                profileId: profileId,
                baseUrl: baseUrl
            }
        };
    },
    getLayout: function getLayout(props) {
        return {
            type: GET_LAYOUT,
            payload: props
        };
    },
    changeReviewsLimit: function changeReviewsLimit(reviewsLimit) {
        return {
            type: SET_REVIEWS_LIMIT,
            payload: {
                reviewsLimit: reviewsLimit
            }
        };
    },
    changeRecommendationsLimit: function changeRecommendationsLimit(recommendationsLimit) {
        return {
            type: SET_RECOMMENDATIONS_LIMIT,
            payload: {
                recommendationsLimit: recommendationsLimit
            }
        };
    },
    changeOffset: function changeOffset(newOffset) {
        return {
            type: SET_OFFSET,
            payload: {
                offset: newOffset
            }
        };
    },
    loadReviewsStatForOne: function loadReviewsStatForOne(profileId, profileType, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: profileType + '/' + profileId + '/aggregate_review',
            method: 'GET',
            actionType: LOAD_REVIEWS_STAT_FOR_ONE
        });
    },
    loadReviewsForOne: function loadReviewsForOne(profileId, profileType) {
        var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constats.DEFAULT_REVIEWS_LIMIT;
        var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constats.DEFAULT_REVIEWS_OFFSET;
        var minReviewRating = arguments[4];
        var xhrConfig = arguments[5];

        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: profileType + '/' + profileId + '/reviews',
            parameters: {
                limit: limit,
                offset: offset,
                status_filter: 'approved',
                verified_filter: true,
                min_rating: minReviewRating
            },
            method: 'GET',
            actionType: LOAD_REVIEWS_FOR_ONE
        });
    },
    changeTab: function changeTab(targetTab) {
        return {
            type: SET_TAB,
            payload: {
                activeTab: targetTab
            }
        };
    },
    changeSpecialist: function changeSpecialist(targetSpecialist) {
        return {
            type: SET_SPECIALIST,
            payload: {
                activeSpecialist: targetSpecialist
            }
        };
    },
    loadReviewsStatForAllDoctors: function loadReviewsStatForAllDoctors(practiceId, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'practices/' + practiceId + '/specialists/reviews/count',
            method: 'GET',
            actionType: LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS
        });
    },
    loadReviewsForAllDoctors: function loadReviewsForAllDoctors(practiceId) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constats.DEFAULT_REVIEWS_LIMIT;
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constats.DEFAULT_REVIEWS_OFFSET;
        var minReviewRating = arguments[3];
        var xhrConfig = arguments[4];

        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'practices/' + practiceId + '/specialists/reviews',
            parameters: {
                limit: limit,
                offset: offset,
                status_filter: 'approved',
                verified_filter: true,
                min_rating: minReviewRating
            },
            method: 'GET',
            actionType: LOAD_REVIEWS_FOR_ALL_DOCTORS
        });
    },
    loadPractice: function loadPractice(practiceId, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'practices/' + practiceId,
            method: 'GET',
            actionType: LOAD_PRACTICE
        });
    },
    loadSpecialist: function loadSpecialist(specialistId, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'specialists/' + specialistId,
            method: 'GET',
            actionType: LOAD_SPECIALIST
        });
    },
    loadRecommendationsStatForAllDoctors: function loadRecommendationsStatForAllDoctors(practiceId, xhrConfig) {
        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'practices/' + practiceId + '/specialists/peer_recommendations/count',
            method: 'GET',
            actionType: LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS
        });
    },
    loadRecommendationsForAllDoctors: function loadRecommendationsForAllDoctors(practiceId) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constats.DEFAULT_REVIEWS_LIMIT;
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constats.DEFAULT_REVIEWS_OFFSET;
        var xhrConfig = arguments[3];

        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: 'practices/' + practiceId + '/specialists/peer_recommendations',
            parameters: {
                limit: limit,
                offset: offset,
                status_filter: 'approved'
            },
            method: 'GET',
            actionType: LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS
        });
    },
    loadRecommendationsForOneDoctor: function loadRecommendationsForOneDoctor(specialistId) {
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constats.DEFAULT_REVIEWS_LIMIT;
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constats.DEFAULT_REVIEWS_OFFSET;
        var xhrConfig = arguments[3];

        return (0, _doctifyUtils.createAction)({
            xhrConfig: xhrConfig,
            url: '/specialists/' + specialistId + '/peer_recommendations',
            parameters: {
                limit: limit,
                offset: offset
            },
            method: 'GET',
            actionType: LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR
        });
    }
};